// ** Third Party Components
import styled from "styled-components";

// ** Utils & Helpers
import DateTime from "utils/datetime";

// #####################################################

const TimePart = styled("span")`
	white-space: nowrap;
`;

// #####################################################

const TimePresenter = ({ date: rawDate, ...rest }) => {
	const date = Number.isInteger(rawDate)
		? new Date(rawDate * 1000).toISOString()
		: rawDate;

	const dt = new DateTime(date);

	const timePart = dt.format("HH:mm"); // Formatuj tylko godzinę i minutę

	// #####################################################

	return timePart ? <TimePart {...rest}>{timePart}</TimePart> : null;
};

// #####################################################

export default TimePresenter;
